export default __webpack_public_path__ + "static/media/Crab.bc1fa936.jpg";